import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { I18nTranslator } from '../../../../i18n/translate';
import { ARColzaCampaign, ARColzaOrder } from '../../../../models/agrorendement-colza.model';
import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { HectareConverterPipe } from '../../../../pipes/hectareConverter.pipe';
import { ListFarmsForOrderPipe, ListUsersForOrderPipe } from '../../../../pipes/orders.pipe';
import { ARColzaService } from '../../../../services/agrorendement-colza.service';
import { FarmService } from '../../../../services/farm.service';
import { OrganisationService } from '../../../../services/organisation.service';
import { OrderComponent } from '../common/orders.component';
import { ARColzaUtils } from './colza.utils';
import { TranslatePipe, TranslateDatePipe, TranslateWithPunctuationPipe } from '../../../../pipes/translate.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'ar-colza-orders-cmp',
  templateUrl: '../common/orders.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    CommonModule,
    FormsModule,
    CampaignYearPipe,
    HectareConverterPipe,
    ListUsersForOrderPipe,
    ListFarmsForOrderPipe,
    TranslatePipe,
    TranslateDatePipe,
    TranslateWithPunctuationPipe,
    PaginationModule,
  ],
  providers: [ARColzaService, FarmService, OrganisationService],
})
export class ARColzaOrderComponent
  extends OrderComponent<ARColzaCampaign, ARColzaOrder>
  implements OnInit, AfterViewInit
{
  @ViewChild('termCampaignFilter') termCampaignFilter: ElementRef;
  @ViewChild('termFarmFilter') termFarmFilter: ElementRef;
  @ViewChild('termOrganisationFilter') termOrganisationFilter: ElementRef;
  @ViewChild('allFilters', { static: true }) allFilters: ElementRef;

  // les arguments du constructeur sont utilisés par la superclasse
  constructor(
    protected service: ARColzaService,
    protected farmService: FarmService,
    protected organisationService: OrganisationService,
    protected i18nTranslator: I18nTranslator,
    protected router: Router,
    protected modal: ModalService,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.colza.section');
    this.specyUrlPart = ['azote', 'colza'];
    this.specyOrderCode = 'ORDC';
  }

  isOrderEditable(order: ARColzaOrder): boolean {
    return ARColzaUtils.isOrderEditable(order);
  }
}
